import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export const getAppVersionByPlatformIdService = params => {
  return axiosRequest('get', `${serviceUrls.GET_APP_VERSION_BY_PLATFORM_ID}`, params);
};

export function updateAppVersionService(data) {
  return axiosRequest('post', serviceUrls.UPDATE_APP_VERSION, data);
}



// WEBPACK FOOTER //
// ./src/services/updateApp.service.js